import Label from '../../../ui/Label'
import { useDispatch } from 'react-redux';
import { addChapel } from '../../../../features/client/clientSlice';
import ClientUpdateBtnWrap from './ClientUpdateBtnWrap';
import useClientAction from '../../../../hooks/actions/useClientAction';
import { useMutationData } from '../../../../hooks/api/useMutationData';
import { useMasterData } from '../../../../hooks/api/useMasterData';

interface ClientModalChapelCheckboxProps {
    typeOfAction: 'newClient' | 'update'
}

export default function ClientModalChapelCheckbox({ typeOfAction }: ClientModalChapelCheckboxProps) {
    
    const dispatch = useDispatch()
    const { handleUpdateChapel, cancelUpdate, clientDataChapels, isChapel } = useClientAction()
    const { isLoadingUpdateClientInfo } = useMutationData()
    const { allChapels } = useMasterData()
    const isUpdateAction = typeOfAction === 'update'
    const chapelList = isUpdateAction ? clientDataChapels : allChapels 
    const isShowAllChapels = isUpdateAction && isChapel
    const allChapelList = isShowAllChapels ? allChapels : chapelList

    return (
        <div className='col-span-2'>
            <Label label={`${!isUpdateAction ? 'Select Chapel *' : 'Selected Chapel *'}`}/>
            <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2`}>
                {allChapelList?.map((chapel, index) => {
                    
                    const isSelected = clientDataChapels?.some((c) => c.chapelID === chapel.chapelID);
                    return (
                        <label
                            key={index}
                            htmlFor={`chapel-${chapel.chapelID}`}
                            className="flex items-center gap-2 cursor-pointer p-2 rounded border border-gray-300"
                        >
                            <input
                                id={`chapel-${chapel.chapelID}`}
                                type="checkbox"
                                className="w-[12px] h-[12px] text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                checked={isSelected}
                                onChange={() => {
                                    dispatch(addChapel({
                                        chapelID: chapel.chapelID,
                                        chapelName: chapel.chapelName
                                    }));
                                }}
                                disabled={isUpdateAction && !isChapel}
                            />
                            <span className="text-gray-700 text-xs">{chapel.chapelName}</span>
                        </label>
                    );
                })}
            </div>
            
            {isUpdateAction && (
                <div className='mt-2'>
                    <ClientUpdateBtnWrap
                        updateType="upChapel"
                        isLoading={isLoadingUpdateClientInfo}
                        onSave={handleUpdateChapel}
                        onCancel={cancelUpdate}
                    />
                </div>
            )}
        </div>
    )
}
